import React, { useState, useEffect } from "react";
import { Carousel as BootstrapCarousel } from "react-bootstrap";
import "../context/carousel.css";

const Carousel = () => {
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    fetch("https://app.andosa.org/ads/get-ads/")
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.status === "successed" && Array.isArray(data.ads)) {
          setCarouselItems(data.ads);
        } else {
          console.log("Failed to fetch ads data");
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const getImageUrl = (imageUrl) => {
    if (imageUrl.startsWith("Images\\")) {
      return `https://app.andosa.org/images/${imageUrl
        .replace("Images\\", "")
        .replace(/\\/g, "/")}`;
    }
    return imageUrl;
  };

  return (
    <BootstrapCarousel
      style={{
        padding: "0px 150px",
        marginTop: "20px",
        height: "300px",
        overflow: "hidden",
        fontFamily: "'Baloo Bhaijaan 2'",
      }}
    >
      {carouselItems.length > 0 ? (
        carouselItems.map((item, index) => (
          <BootstrapCarousel.Item key={index}>
            <img
              className="d-block w-100"
              src={getImageUrl(item.image)}
              alt={`Slide ${index + 1}`}
              height={300}
              width={500}
              style={{
                objectFit: "cover",
                borderRadius: "10px",
                border: "2px solid #eee",
              }}
            />
            <BootstrapCarousel.Caption
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}
            >
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </BootstrapCarousel.Caption>
          </BootstrapCarousel.Item>
        ))
      ) : (
        <div
          className="text-center"
          style={{ width: "100%", padding: "50px 0" }}
        >
          <p>لا توجد إعلانات حالياً لعرضها</p>
        </div>
      )}
    </BootstrapCarousel>
  );
};

export default Carousel;
